import Button from 'components/UI/Button';
import StyledSubmitedAlert from './styles';

const Connection = () => (
    <StyledSubmitedAlert>
        <h3>Thank you!</h3>
        <p>
            Your information has been successfully submitted. Our team will contact you as soon as possible to proceed with the process.
        </p>
        <a href="https://fasttoken.com/">
            <Button>BACK TO HOME</Button>
        </a>
    </StyledSubmitedAlert>
);

export default Connection;
